import { ImgHTMLAttributes, useEffect, useState } from 'react';
import { apiClient } from '../utils';

export function LocalImage(props: ImgHTMLAttributes<HTMLImageElement>) {
  const [imgSrc, setImgSrc] = useState<string>();

  const { src, alt, ...otherProps } = props;

  useEffect(() => {
    if (!src) {
      return;
    }

    apiClient
      .get(src)
      .then((response: any) => {
        setImgSrc(response.data);
      })
      .catch((reason: any) => {
        console.log(reason);
      });
  }, [src]);

  if (!imgSrc) {
    return null;
  }

  return <img src={imgSrc} alt={alt} {...otherProps} />;
}
